export default __webpack_public_path__ + "static/media/icon_BNB.bde79f25.svg";